import type { AsyncOption } from "@/components/async-combobox";
import { searchOrganizationProductsPath } from "@/routes";

/**
 * Fetch product options from the server for AsyncCombobox
 * @param term - Search term
 * @param organizationSlug - Organization slug for tenant-scoped search
 * @returns Promise with array of AsyncOptions
 */
export async function fetchProductOptions(
  term: string,
  organizationSlug?: string | null,
): Promise<AsyncOption[]> {
  if (!organizationSlug) {
    console.warn("fetchProductOptions called without organizationSlug");
    return [];
  }

  const params = new URLSearchParams();
  params.set("term", term || "");
  
  const searchPath = searchOrganizationProductsPath(organizationSlug);
  const res = await fetch(`${searchPath}?${params.toString()}`);
  
  if (!res.ok) return [];
  
  const data = (await res.json()) as { id: number; value: number; label: string }[];
  return data.map((p) => ({ value: p.id, label: p.label }));
}
